<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
        <h5>{{ reportTitle }}</h5>
        <h6>{{ reportDescription }}</h6>
        <h6>Download full report: <span class="text-capitalize" style="font-size: 16px; font-weight: bold;">{{ full_report }}</span></h6>
        <a href="" @click.prevent="generateReport">Download Task Report</a>

      <app-table
      :id="tableId"
      :options="options"
      @action="getListAction"
  />
    </div>
  </div>
</template>
  
<script>
  import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";
  import * as actions from "../../../../../Config/ApiUrl";
  import {TableHelpers} from "../../../Demo/Tables/mixins/TableHelpers";
  import {axiosPost, axiosGet} from "@/app/Helpers/AxiosHelper";

  
  export default {
  extends: CoreLibrary,
  name: "TaskReportDetail",
  mixins: [TableHelpers],
  props: {
    report_id: Number,
    report_detail: Object,
  },
  data() {
    return {
      reportDescription: 'Description: '+this.report_detail.description ?? '---',
      reportTitle: 'Title: '+this.report_detail.title ?? '--',
      full_report: this.report_detail.full_report,
      preloader: false,
      tableId: "task-report-detail",
      rowData: {},
      options: {
        name: this.$t("tab_filter"),
        url: actions.TASK_REPORT_DETAL+'?report_id='+this.report_id,
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("title"),
            type: "custom-html",
            key: "report_path",
            modifier: (value,row) => {
              var path = value == null ? '---' : `<a class="text-primary cursor-pointer" id="${row.id}"  @click.prevent=${this.myFunction(row)}>${this.$t(value)}</a>`;
              return path;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value, row) => {
              let ClassName = "warning";
              if (value === "completed") ClassName = `success`;
              else if (value === "inprogress") ClassName = `dark`;
              return `<span class="text-capitalize badge badge-sm badge-pill badge-${ClassName}">${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("create_time"),
            type: "custom-html",
            key: "create_time",
            modifier: (value) => {
              var date = moment(value).format("YYYY-MM-DD hh:mm");
              return `<span>${this.$t(date)}</span>`;
            },
          },
          {
            title: this.$t("update_time"),
            type: "custom-html",
            key: "update_time",
            modifier: (value) => {
              var date = value == null ? '---' : moment(value).format("YYYY-MM-DD hh:mm");
              return `<span>${this.$t(date)}</span>`;
            },
          },

        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("delete"),
            icon: "delete",
            type: "none",
          },

        ],
        showFilter: false,
        showCount: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 5,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },

    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];

  },
  methods: {
    downloadPdf(path) {
      window.location.href = actions.COMPANY_REPORT_DOWNLOAD+'?path='+path;
    },
    myFunction(rowData){
            let doc = document.getElementById(rowData.id);
            if(doc){
                doc.addEventListener('click', () => {
                  this.downloadPdf(rowData.report_path);
                })
            }
        },
    async generateReport(){
      axiosPost(actions.TASK_REPORT_GENERATE, {report_id:this.report_id, reportType:'Task'})
          .then((response) => {
            if (response.data.status == 200) {
                if (response.data.type == 'info') {
                  this.$toastr.i(response.data.message);
                  this.preloader = false;
                }
                else {
                  this.$toastr.s(response.data.message);
                  this.preloader = false;
                }         
            }
          })
          .catch((error, message) => {
            // Trigger after error
            console.log(error, message)

          })
          .finally(() => {
            this.loadDataTable();
          });

          this.loadDataTable();
    },

    loadDataTable() {
      let instance = this;
      setTimeout(function () {
        instance.$hub.$emit("reload-" + instance.tableId);
      },1000);
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t('delete')) {
        this.deleteReportFile(rowData);
      }


    },

    deleteReportFile(rowData) {
      this.preloader = true;
      axiosPost('admin/report/delete-file',rowData)
       .then((response) => {
         this.$toastr.s(response.data.message);
          this.preloader = false;

      }).catch((error, message) => {
            // Trigger after error
            console.log(error, message)
      }).finally(() => {
            this.loadDataTable();
          });
    }
  },
  mounted() {

  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
  </script>
  